import { render, staticRenderFns } from "./AccountingTransactionShow.vue?vue&type=template&id=5f9b8cd2&"
import script from "./AccountingTransactionShow.vue?vue&type=script&lang=js&"
export * from "./AccountingTransactionShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports